// extracted by mini-css-extract-plugin
export var connectionButton = "_bi-1";
export var connectionButtonFloating = "_bi-2";
export var connectionContainer = "_bi-0";
export var rightPanel = "_bi-6";
export var stepCard = "_bi-3";
export var stepCardSubtitle = "_bi-5";
export var stepCardText = "_bi-4";